<div class="container">
    <div class="row">
        <div class="col-12 col-md-4 col-lg-4">
            <div class="float-start">
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Ofertas</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://ofertas.yamaha.bo/" class="text-uppercase ff-medium" (click)="cerrarMenu()">Motos</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div style="border-left: 1px solid #000; height: 100px;" class="float-end mb-4"></div>
        </div>
        <div class="col-12 col-md-4 col-lg-4">
            <div class="float-start">
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3" >Noticias</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://noticias.toyosa.com/yamaha" class="text-uppercase ff-medium" (click)="cerrarMenu()">Yamaha</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
